import { SVGProps } from 'react';

const SvgTree = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M241.8 7.9c-4.5-5-11-7.9-17.8-7.9s-13.3 2.9-17.8 7.9l-144 160c-6.3 7-7.9 17.2-4.1 25.8S70.5 208 80 208h11.8l-62 72.4c-6.1 7.1-7.5 17.1-3.6 25.6s12.4 14 21.8 14h24L4.8 409.6c-5.5 7.3-6.3 17-2.3 25.1S14.9 448 24 448h176v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h176c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1L376 320h24c9.4 0 17.9-5.5 21.8-14s2.5-18.5-3.6-25.6l-62-72.4H368c9.5 0 18.1-5.6 21.9-14.2s2.3-18.8-4.1-25.8L241.8 8zM248 400V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v184H72l67.2-89.6c5.5-7.3 6.3-17 2.3-25.1S129.1 272 120 272h-19.8l62-72.4c6.1-7.1 7.5-17.1 3.6-25.6s-12.4-14-21.8-14h-10.1L224 59.9 314.1 160H304c-9.4 0-17.9 5.5-21.8 14s-2.5 18.5 3.6 25.6l62 72.4H328c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1L376 400H248z" />
  </svg>
);
export default SvgTree;
